import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const TrojanHorse = {
  id: '37',
  name: "Trojan Horse",
  width: 3,
  height: 3,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Trojan_Horse',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Trojan_Horse',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          if (level <= 7) {
            return 0;
          }
          if (level <= 11) {
            return 1;
          }
          if (level <= 16) {
            return 2;
          }
          if (level <= 24) {
            return 3;
          }
          if (level <= 39) {
            return 4;
          }
          if (level <= 43) {
            return 5;
          }
          if (level <= 47) {
            return 6;
          }
          if (level <= 51) {
            return 7;
          }
          if (level <= 55) {
            return 8;
          }
          if (level <= 59) {
            return 9;
          }
          return 10;
        }
      ).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          0,35,35,54,54,69,69,69,87,87,99,99,99,114,114,124,124,124,137,137,145,145,154,154,154,165,165,173,173,180,180,187,187,194,194,201,201,208,211,215,218,222,225,229,232,236,239,243,246,250,253,257,260,264,267,271,274,278,281,285
        ],
        bronzeAge: [
          0,42,42,65,65,83,83,83,104,104,119,119,119,137,137,149,149,149,164,164,174,174,185,185,185,198,198,208,208,216,216,224,224,233,233,241,241,250,253,258,262,266,270,274,279,283,287,291,295,300,304,308,312,316,321,325,329,333,337,342
        ],
        minoanEra: [
          0,50,50,75,75,96,96,96,122,122,138,138,138,160,160,173,173,173,192,192,204,204,215,215,215,231,231,242,242,252,252,262,262,272,272,281,281,291,296,301,306,311,316,321,326,331,336,341,346,351,356,361,366,371,376,381,386,391,396,401
        ],
        classicGreece: [
          0,80,80,121,121,154,154,154,197,197,222,222,222,256,256,278,278,278,308,308,327,327,345,345,345,372,372,389,389,405,405,421,421,437,437,452,452,467,474,482,489,497,504,512,519,527,534,542,549,557,564,572,579,587,594,602,609,617,624,632
        ],
        earlyRome: [
          0,98,98,148,148,189,189,189,240,240,271,271,271,313,313,340,340,340,377,377,400,400,422,422,422,454,454,475,475,495,495,515,515,534,534,552,552,571,580,590,599,609,618,628,637,647,656,666,675,685,694,704,713,723,732,742,751,761,770,780
        ],
        romanEmpire: [
          0,115,115,175,175,223,223,223,284,284,321,321,321,370,370,401,401,401,445,445,473,473,499,499,499,537,537,562,562,585,585,608,608,631,631,653,653,674,684,695,705,716,726,737,747,758,768,779,789,800,810,821,831,842,852,863,873,884,894,905
        ],
        byzantineEra: [
          0,115,115,175,175,223,223,223,284,284,321,321,321,370,370,401,401,401,445,445,473,473,499,499,499,537,537,562,562,585,585,608,608,631,631,653,653,674,684,695,705,716,726,737,747,758,768,779,789,800,810,821,831,842,852,863,873,884,894,905
        ],
        ageOfTheFranks: [
          0,115,115,175,175,223,223,223,284,284,321,321,321,370,370,401,401,401,445,445,473,473,499,499,499,537,537,562,562,585,585,608,608,631,631,653,653,674,684,695,705,716,726,737,747,758,768,779,789,800,810,821,831,842,852,863,873,884,894,905
        ],
        feudalAge: [
          0,115,115,175,175,223,223,223,284,284,321,321,321,370,370,401,401,401,445,445,473,473,499,499,499,537,537,562,562,585,585,608,608,631,631,653,653,674,684,695,705,716,726,737,747,758,768,779,789,800,810,821,831,842,852,863,873,884,894,905
        ],
        iberianEra: [
          0,115,115,175,175,223,223,223,284,284,321,321,321,370,370,401,401,401,445,445,473,473,499,499,499,537,537,562,562,585,585,608,608,631,631,653,653,674,684,695,705,716,726,737,747,758,768,779,789,800,810,821,831,842,852,863,873,884,894,905
        ],
        kingdomOfSicily: [
          0,115,115,175,175,223,223,223,284,284,321,321,321,370,370,401,401,401,445,445,473,473,499,499,499,537,537,562,562,585,585,608,608,631,631,653,653,674,684,695,705,716,726,737,747,758,768,779,789,800,810,821,831,842,852,863,873,884,894,905
        ],
        highMiddleAges: [
          0,115,115,175,175,223,223,223,284,284,321,321,321,370,370,401,401,401,445,445,473,473,499,499,499,537,537,562,562,585,585,608,608,631,631,653,653,674,684,695,705,716,726,737,747,758,768,779,789,800,810,821,831,842,852,863,873,884,894,905
        ],
        earlyGothicEra: [
          0,115,115,175,175,223,223,223,284,284,321,321,321,370,370,401,401,401,445,445,473,473,499,499,499,537,537,562,562,585,585,608,608,631,631,653,653,674,684,695,705,716,726,737,747,758,768,779,789,800,810,821,831,842,852,863,873,884,894,905
        ],
        lateGothicEra: [
          0,115,115,175,175,223,223,223,284,284,321,321,321,370,370,401,401,401,445,445,473,473,499,499,499,537,537,562,562,585,585,608,608,631,631,653,653,674,684,695,705,716,726,737,747,758,768,779,789,800,810,821,831,842,852,863,873,884,894,905
        ]
      }).withOutput(ProductionOutputType.CURRENT_ERA_PRIMARY_GOODS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          4000,4000,7700,7700,10500,10500,12800,12800,12800,15900,15900,15900,18600,18600,20300,20300,20300,22600,22600,24100,24100,25500,25500,26900,26900,26900,28800,28800,30100,30100,31300,31300,32500,32500,33700,33700,34800,34800,36000,36900,37800,38700,39600,40500,41400,42300,43200,44100,45000,45900,46800,47700,48600,49500,50400,51300,52200,53100,54000,54900
        ],
        bronzeAge: [
          5150,5150,10000,10000,13600,13600,16600,16600,16600,20600,20600,20600,24100,24100,26200,26200,26200,29300,29300,31200,31200,33000,33000,34800,34800,34800,37300,37300,39000,39000,40500,40500,42100,42100,43600,43600,45100,45100,46500,48000,49200,50400,51600,52800,54000,55200,56400,57600,58800,60000,61200,62400,63600,64800,66000,67200,68400,69600,70800,72000
        ],
        minoanEra: [
          9050,9050,17500,17500,23800,23800,29200,29200,29200,36100,36100,36100,42300,42300,46100,46100,46100,51400,51400,54700,54700,58000,58000,61100,61100,61100,65500,65500,68400,68400,71200,71200,73900,73900,76600,76600,79200,79200,81700,84000,86100,88200,90300,92400,94500,96600,98700,100800,102900,105000,107100,109200,111300,113400,115500,117600,119700,121800,123900,126000
        ],
        classicGreece: [
          13400,13400,25800,25800,35100,35100,42900,42900,42900,53200,53200,53200,62200,62200,67800,67800,67800,75700,75700,80600,80600,85300,85300,89900,89900,89900,96500,96500,101000,101000,105000,105000,109000,109000,113000,113000,117000,117000,120000,123000,126000,129000,132000,135000,138000,141000,144000,147000,150000,153000,156000,159000,162000,165000,168000,171000,174000,177000,180000,183000
        ],
        earlyRome: [
          15900,15900,30700,30700,41700,41700,51000,51000,51000,63200,63200,63200,74000,74000,80600,80600,80600,89900,89900,95800,95800,101000,101000,107000,107000,107000,115000,115000,120000,120000,125000,125000,129000,129000,134000,134000,139000,139000,143000,142600,146100,149600,153100,156600,160100,163600,167100,170600,174100,177600,181100,184600,188100,191600,195100,198600,202100,205600,209100,212600
        ],
        romanEmpire: [
          18500,18500,35800,35800,48600,48600,59500,59500,59500,73700,73700,73700,86300,86300,94000,94000,94000,105000,105000,112000,112000,118000,118000,125000,125000,125000,134000,134000,140000,140000,145000,145000,151000,151000,156000,156000,162000,162000,167000,163000,167000,171000,175000,179000,183000,187000,191000,195000,199000,203000,207000,211000,215000,219000,223000,227000,231000,235000,239000,243000
        ],
        byzantineEra: [
          21700,21700,41900,41900,56900,56900,69700,69700,69700,86300,86300,86300,101000,101000,110000,110000,110000,123000,123000,131000,131000,138000,138000,146000,146000,146000,157000,157000,163000,163000,170000,170000,177000,177000,183000,183000,189000,189000,195000,172000,176300,180600,184900,189200,193500,197800,202100,206400,210700,215000,219300,223600,227900,232200,236500,240800,245100,249400,253700,258000
        ],
        ageOfTheFranks: [
          24800,24800,48000,48000,65200,65200,79800,79800,79800,98800,98800,98800,116000,116000,126000,126000,126000,141000,141000,150000,150000,159000,159000,167000,167000,167000,179000,179000,187000,187000,195000,195000,202000,202000,210000,210000,217000,217000,224000,229700,235400,241100,246800,252500,258200,263900,269600,275300,281000,286700,292400,298100,303800,309500,315200,320900,326600,332300,338000,343700
        ],
        feudalAge: [
          29200,29200,56500,56500,76700,76700,93900,93900,93900,116000,116000,116000,136000,136000,148000,148000,148000,166000,166000,176000,176000,187000,187000,196000,196000,196000,211000,211000,220000,220000,229000,229000,238000,238000,247000,247000,255000,255000,264000,270700,277400,284100,290800,297500,304200,310900,317600,324300,331000,337700,344400,351100,357800,364500,371200,377900,384600,391300,398000,404700
        ],
        iberianEra: [
          34400,34400,66500,66500,90200,90200,110000,110000,110000,136000,136000,136000,160000,160000,174000,174000,174000,195000,195000,207000,207000,220000,220000,231000,231000,231000,248000,248000,259000,259000,269000,269000,280000,280000,291000,291000,300000,300000,311000,320000,328000,336000,344000,352000,360000,368000,376000,384000,392000,400000,408000,416000,424000,432000,440000,448000,456000,464000,472000,480000
        ],
        kingdomOfSicily: [
          36000,36000,69600,69600,94400,94400,115000,115000,115000,142000,142000,142000,167000,167000,182000,182000,182000,204000,204000,217000,217000,230000,230000,242000,242000,242000,259000,259000,271000,271000,281000,281000,293000,293000,304000,304000,314000,314000,325000,340000,348500,357000,365500,374000,382500,391000,399500,408000,416500,425000,433500,442000,450500,459000,467500,476000,484500,493000,501500,510000
        ],
        highMiddleAges: [
          40000,40000,75000,75000,100000,100000,125000,125000,125000,150000,150000,150000,185000,185000,200000,200000,200000,225000,225000,240000,240000,255000,255000,265000,265000,265000,275000,275000,280000,280000,300000,300000,315000,315000,325000,325000,335000,335000,350000,360000,369000,378000,387000,396000,405000,414000,423000,432000,441000,450000,459000,468000,477000,486000,495000,504000,513000,522000,531000,540000
        ],
        earlyGothicEra: [
          42000,42000,80000,80000,106000,106000,133000,133000,133000,159000,159000,159000,196000,196000,212000,212000,212000,239000,239000,254000,254000,270000,270000,281000,281000,281000,292000,292000,297000,297000,318000,318000,334000,334000,345000,345000,355000,355000,371000,380000,389500,399000,408500,418000,427500,437000,446500,456000,465500,475000,484500,494000,503500,513000,522500,532000,541500,551000,560500,570000
        ],
        lateGothicEra: [
          0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0
        ]
      }).withOutput(ProductionOutputType.FOOD),
    ),
  ]),
};

export default TrojanHorse;
